// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vas-wallet-report .wallet-summary {
    background-color: transparent;
    border-radius: 0;
}

.vas-wallet-report .wallet-trans {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 10px;
    /* display: flex;
    flex: auto auto auto; */
}

.vas-wallet-report .wallet-trans p {
    color: #000000;
    margin-bottom: 0;
}

.vas-wallet-report .wallet-trans .total-label {
    font-size: 10px;
    text-transform: uppercase;
    opacity: 1;
    padding-top: 30px;
}

.vas-wallet-report .wallet-trans .total-value {
    font-size: 20px;
    margin-top: 5px;
}

.vas-wallet-report .wallet-trans .total-value span {
    font-weight: 600;
}

.vas-wallet-report .wallet-trans .count-label {
    font-size: 10px;
    text-transform: uppercase;
    color: #9B9B9B;
    margin-top: 15px;
}

.vas-wallet-report .wallet-trans .bordered {
    border-right: 1px solid #5a5a5a;
    border-left: 1px solid #5a5a5a;
}

.vas-wallet-report .wallet-summary .user-summary {
    background-color: #000000;
    border-radius: 10px;
    padding: 10px;
    display: flex;
    justify-content: center;
    padding-bottom: 42px;
}

.vas-wallet-report .chart-doughnut {
    width: 100px;
}

/* .vas-wallet-report .filter {
    background-color: #060D27;
    border: none;
    height: 44px;
    padding-inline: 20px;
    margin-left: 10px;
} */

.vas-wallet-report .wallet-funding {
    padding: 10px;
    color: #000000;
}

.vas-wallet-report .card {
    border-radius: 8px;
}

.vas-wallet-report .credit {
    background-color: #ECFDEE;
    margin-bottom: 10px;
    border-radius: 14px;
}

.vas-wallet-report .debit {
    background-color: #FFEFE0;
    border-radius: 14px;
}

.vas-wallet-report .wallet-funding h3 {
    font-size: 10px;
    text-transform: uppercase;
    color: #5A5656;
    font-weight: 600;
    margin-bottom: 15px;
}

.vas-wallet-report .funding-label {
    font-size: 10px;
    margin-bottom: 2px;
}

.vas-wallet-report .funding-amount {
    font-size: 20px;
    margin-bottom: 0;
}

.vas-wallet-report .funding-amount span {
    font-weight: 600;
}

.vas-wallet-report .wallet-trans .total-trans-amount {
    background-color: #D8D8D8;
    padding: 10px;
    border-radius: 10px;
}

.vas-wallet-report .wallet-trans .total-credit {
    background-color: #ECFDEE;
    padding: 10px;
    border-radius: 10px;
}

.vas-wallet-report .wallet-trans .total-debit {
    background-color: #FFEFE0;
    padding: 10px;
    border-radius: 10px;
}

`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/vas-transactions/WalletReport.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb;2BACuB;AAC3B;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;;;;GAMG;;AAEH;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".vas-wallet-report .wallet-summary {\n    background-color: transparent;\n    border-radius: 0;\n}\n\n.vas-wallet-report .wallet-trans {\n    background-color: #ffffff;\n    border-radius: 10px;\n    padding: 10px;\n    /* display: flex;\n    flex: auto auto auto; */\n}\n\n.vas-wallet-report .wallet-trans p {\n    color: #000000;\n    margin-bottom: 0;\n}\n\n.vas-wallet-report .wallet-trans .total-label {\n    font-size: 10px;\n    text-transform: uppercase;\n    opacity: 1;\n    padding-top: 30px;\n}\n\n.vas-wallet-report .wallet-trans .total-value {\n    font-size: 20px;\n    margin-top: 5px;\n}\n\n.vas-wallet-report .wallet-trans .total-value span {\n    font-weight: 600;\n}\n\n.vas-wallet-report .wallet-trans .count-label {\n    font-size: 10px;\n    text-transform: uppercase;\n    color: #9B9B9B;\n    margin-top: 15px;\n}\n\n.vas-wallet-report .wallet-trans .bordered {\n    border-right: 1px solid #5a5a5a;\n    border-left: 1px solid #5a5a5a;\n}\n\n.vas-wallet-report .wallet-summary .user-summary {\n    background-color: #000000;\n    border-radius: 10px;\n    padding: 10px;\n    display: flex;\n    justify-content: center;\n    padding-bottom: 42px;\n}\n\n.vas-wallet-report .chart-doughnut {\n    width: 100px;\n}\n\n/* .vas-wallet-report .filter {\n    background-color: #060D27;\n    border: none;\n    height: 44px;\n    padding-inline: 20px;\n    margin-left: 10px;\n} */\n\n.vas-wallet-report .wallet-funding {\n    padding: 10px;\n    color: #000000;\n}\n\n.vas-wallet-report .card {\n    border-radius: 8px;\n}\n\n.vas-wallet-report .credit {\n    background-color: #ECFDEE;\n    margin-bottom: 10px;\n    border-radius: 14px;\n}\n\n.vas-wallet-report .debit {\n    background-color: #FFEFE0;\n    border-radius: 14px;\n}\n\n.vas-wallet-report .wallet-funding h3 {\n    font-size: 10px;\n    text-transform: uppercase;\n    color: #5A5656;\n    font-weight: 600;\n    margin-bottom: 15px;\n}\n\n.vas-wallet-report .funding-label {\n    font-size: 10px;\n    margin-bottom: 2px;\n}\n\n.vas-wallet-report .funding-amount {\n    font-size: 20px;\n    margin-bottom: 0;\n}\n\n.vas-wallet-report .funding-amount span {\n    font-weight: 600;\n}\n\n.vas-wallet-report .wallet-trans .total-trans-amount {\n    background-color: #D8D8D8;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.vas-wallet-report .wallet-trans .total-credit {\n    background-color: #ECFDEE;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n.vas-wallet-report .wallet-trans .total-debit {\n    background-color: #FFEFE0;\n    padding: 10px;\n    border-radius: 10px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
